import instance from "../root.api";

export const updateArticleLogRequest = (lesson) =>
  instance
    .post(`/articles-logs`, { lesson })
    .then((response) => ({ response }));

export const updateVideoLogRequest = (data) =>
  instance.post(`/watch-logs`, data).then((response) => ({ response }));
